import {UI} from "../../stem-core/src/ui/UI";

import {Dispatcher} from "../../stem-core/src/base/Dispatcher";


// TODO @cleanup using this seems like a huge hack
export const ClickPreprocessors = {
    initialized: false,
    clickPreprocessors: new Dispatcher(),

    init: function () {
        if (this.initialized) {
            return;
        }
        this.initialized = true;
        const {clickPreprocessors} = this;

        UI.Element.prototype.addClickListener = function(callback) {
            this.addNodeListener("click", (...args) => {
                clickPreprocessors.dispatch(this);
                callback(...args);
            });
        }
    },

    addCallback: function (callback) {
        this.clickPreprocessors.addListener(callback);
    }
}
